<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>
    <a-card>
      <div class="text-right">
        <a-button
          type="primary"
          icon="plus"
          class="add-btn"
          @click="visibleAdd"
          style="margin-right:30px;"
        >
          新增国家
        </a-button>
        <a-button
          type="primary"
          icon="plus"
          class="upload-btn"
          @click="showVisible = true"
        >
          批量上传
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <a-button type="link" size="small" @click="handleEdit(tableRow)">
              编辑
            </a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              title="此操作将删除该项信息, 是否继续?"
              @confirm="handleDeleteConfirm(tableRow)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a-button type="link" size="small">
                删除
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </TableView>
      <a-modal
        v-model="visible"
        destroyOnClose
        @ok="handleSubmit"
        :title="modalTitle"
        :maskClosable="false"
        :afterClose="handleAfterClose"
      >
        <a-form :form="modalForm">
          <a-form-item label="国家名称">
            <a-input
              :maxLength="100"
              allowClear
              :disabled="disabled"
              v-decorator="$decorator('countryName', '国家名称不能为空')"
            ></a-input>
          </a-form-item>
          <a-form-item label="年份">
            <a-input
              :maxLength="100"
              :disabled="disabled"
              allowClear
              v-decorator="$decorator('year', '年份不能为空')"
            ></a-input>
          </a-form-item>
          <a-form-item label="国家评级">
            <a-select
              :maxLength="100"
              allowClear
              showSearch
              v-decorator="$decorator('rate', '国家评级不能为空')"
              option-filter-prop="children"
            >
              <a-select-option
                v-for="item in rateList"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
    <a-modal
      v-model="showVisible"
      destroyOnClose
      @ok="handleOk"
      title="批量上传"
      :maskClosable="false"
    >
      <a-form :form="form" :labelCol="{ span: 4 }">
        <a-form-item label="附件上传">
          <a-upload
            name="file"
            :beforeUpload="handleBeforeUpload"
            @change="handleFileChange"
            :fileList="fileList"
            :remove="handleRemove"
          >
            <a-button>
              <a-icon type="upload" />
              选取文件
            </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item label="模板下载">
          <a-button type="link" @click="handleTemplateDownload">
            点击下载
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData, add, remove, Upload, templateDownload } from './api'
import moment from 'moment'

export default {
  mixins: [mixin],
  data() {
    const rateList = [
      {
        id: 'AAA',
        name: 'AAA',
      },
      {
        id: 'AA+',
        name: 'AA+',
      },
      {
        id: 'AA',
        name: 'AA',
      },
      {
        id: 'AA-',
        name: 'AA-',
      },
      {
        id: 'A+',
        name: 'A+',
      },
      {
        id: 'A',
        name: 'A',
      },
      {
        id: 'A-',
        name: 'A-',
      },
      {
        id: 'BBB',
        name: 'BBB',
      },
      {
        id: 'BB',
        name: 'BB',
      },
      {
        id: 'B',
        name: 'B',
      },
    ]

    return {
      headers: { 'Content-Type': 'multipart/form-data' },
      showVisible: false,
      rateList,
      visible: false,
      yearShowOne: false,
      disabled: false,
      modalTitle: '新增',
      modalForm: this.$form.createForm(this),
      yaerMode: '',
      form: this.$form.createForm(this),
      fileList: [],
      tableLoading: true,
    }
  },
  components: {
    SearchView,
    TableView,
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    // 模板下载
    async handleTemplateDownload() {
      try {
        await templateDownload()
      } catch (e) {
        // No processing
      }
    },
    visibleAdd() {
      this.visible = true
      this.modalTitle = '新增'
      this.disabled = false
    },
    panelChangeOne(value) {
      this.yaerMode = moment(value).format('YYYY')
      this.yearShowOne = !this.yearShowOne
    },
    handleOpenChange() {
      this.yearShowOne = !this.yearShowOne
    },
    // 删除文件上传
    handleRemove(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid)
      this.remove(index)
    },
    handleFileChange() {
      if (this.fileList.length > 1) {
        this.fileList.shift()
      }
    },
    // 本地删除
    remove(index) {
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    // 上传文件前
    handleBeforeUpload(file) {
      this.fileList = [...this.fileList, file]
      return false
    },
    // 批量上传
    // 文件上传提交
    async handleOk() {
      const { fileList } = this
      try {
        const { message } = await Upload({
          file: fileList,
        })
        this.visible = false
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
        this.fileList = []
      } catch (e) {
        // No processing
      }
      this.showVisible = false
    },
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }
      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = null
          }
          try {
            const { message } = await add({
              ...values,
              id: this.id,
            })
            this.visible = false
            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            console.log(e)
            // No processing
          }
        }
      })
    },
    handleAfterClose() {
      this.id = null
      this.modalTitle = '新增'
    },

    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    handleEdit({ countryName, year, rate, id }) {
      this.visible = true
      this.modalTitle = '编辑'
      this.modalTitle === '编辑'
        ? (this.disabled = true)
        : (this.disabled = false)
      setTimeout(() => {
        this.modalForm.setFieldsValue({
          countryName,
          year,
          rate,
        })
        this.id = id
      }, 20)
    },
  },
}
</script>
